// extracted by mini-css-extract-plugin
export var container = "_7s-2";
export var content = "_7s-1";
export var phoneCard = "_7s-4";
export var smsImage = "_7s-3";
export var textarea = "_7s-0";